export default __webpack_public_path__ + "static/media/a2.61bc2d00.png";